import { Fragment, useContext, useEffect } from 'react'
import DocumentsConsideration from './DocumentsConsideration/DocumentsConsideration'
import { Alert, Line } from './styles'
import useSupportingDocumentsForClaim from '@/hooks/useSupportingDocumentsForClaim'
import { useRecoilValue } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm/atom'
import { DocumentItem } from './types'
import { DocumentContext, DocumentDispatchContext } from '../HealthClaimDetailPage'

const SupportingDocumentsForClaimTabDocument = () => {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const claimDocuments = healthClaim.data?.claimDocuments

  const { textAlert, getAttachmentUrls, initialState, documentConfigs } =
    useSupportingDocumentsForClaim()

  const dispatch = useContext(DocumentDispatchContext)
  const documents = useContext(DocumentContext)

  useEffect(() => {
    if (!claimDocuments) {
      dispatch({ type: 'INIT', payload: initialState })
      return
    }

    const updatedState: DocumentItem[] = documentConfigs.map((config) => ({
      ...config,
      claimDocuments: claimDocuments.filter(
        (claim: any) => claim.documentType?.code === config.code,
      ),
      uploadClaimDocuments: [],
    }))

    dispatch({ type: 'INIT', payload: updatedState })
  }, [claimDocuments, documentConfigs, healthClaim.mode])

  return (
    <>
      <Alert type="info" showIcon message={textAlert} />
      {documents.map((doc) => (
        <Fragment key={doc.code}>
          <DocumentsConsideration
            {...doc}
            gallery={getAttachmentUrls(documents)}
            dispatch={dispatch}
          />
          <Line />
        </Fragment>
      ))}
    </>
  )
}

export default SupportingDocumentsForClaimTabDocument
